module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aAt8U"))).then(() => parcelRequire('f4eak'));